
// Alert
//  {
//       "_id": "6892394a8947f311796cf6b7",
//       "type": "ACCEPT_IMPORTED_APPS",
//       "title": "Accept Imported Applications",
//       "status": 3,
//       "brand_relationship_id": 29484,
//       "total": 25,
//       "user_id": 1,
//       "updated_at": "2025-08-05 17:03:07",
//       "created_at": "2025-08-05 17:03:06",
//       "ended_at": "2025-08-05 17:03:07",
//       "progress": 100,
//       "number_processed": 25
//  }
// Alert type and title
// "IMPORT_UPLOADED" => "Import Uploaded"
// "ACCEPT_IMPORTED" => "Accepted Import"
// "ACCEPT_IMPORTED_APPS" => "Accepted Imported Apps"
// "ACCEPT_PRICESHEETS" => "Accepted Price Sheets"
// "ACCEPT_MARKETCOPY" => "Accepted Market Copies"
// "UPDATE_ITEM_STATUS" => "Update Item Status"
// "UPDATE_ITEM_STATUS_DRAFT" => "Update Item Status Draft"
// "UPDATE_ITEM_STATUS_REVIEW" => "Update Item Status Review"
// "UPDATE_ITEM_STATUS_APPROVED" => "Update Item Status Approved"
// "PUBLISH_ITEMS" => "Publish Items"
// "UPDATE_ASSET_STATUS" => "Update Asset Status"
// "UPDATE_PRICESHEET_STATUS" => "Update Price sheet Status"
// "UPDATE_MARKETCOPY_STATUS" => "Update Market Copy Status"
// "EXPORT" => "Type Export"
// "EXPORT_RERUN" => "Export Rerun"
// "EXPORT_PIES65" => "Export Pies 6.5"
// "EXPORT_PIES67" => "Export Pies 6.7"
// "EXPORT_PIES70" => "Export Pies 7.0"
// "EXPORT_PIES71" => "Export Pies 7.1"
// "EXPORT_PIES72" => "Export Pies 7.2"
// "EXPORT_ACES30" => "Export Aces 3.0"
// "EXPORT_ACES32" => "Export Aces 3.2"
// "EXPORT_ACES40" => "Export Aces 4.0"
// "EXPORT_ACES41" => "Export Aces 4.1"
// "EXPORT_ACES42" => "Export Aces 4.2"
// "EXPORT_ACES32_OREILLY" => "Export Aces 3.2 Orelly"
// "EXPORT_ASSETS" => "Export Assets"
// "BULK_UPDATE_ITEMS" => "Bulk Update Items"
// "ADD_TO_DATA_LIST" => "Add To Data List"
// "ADD_VCDB_FITMENTS_TO_ITEMS" => "Add Vcdb Fitments To Items"
// "ADD_VCDB_FITMENTS_TO_ITEMS_VIA_LIST" => "Add Vcdb Fitments To Items Via List"
// "ADD_TO_FITMENTS_LIST_VIA_FITMENT_LIST" => "Add To Fitments List Via Fitments List"
// "ADD_TO_FITMENTS_LIST_VIA_ITEM_APPS" => "Add To Fitments List Via Item Apps"
// "REMOVE_FITMENTS_FROM_ITEM" => "Remove Fitments From Item"
// "ADD_TO_ITEMS_VIA_FITMENT_LIST" => "Add To Items Via Fitments List"
// "DELETE_ITEM" => "Delete Item"
// "UNARCHIVE_ITEM" => "Unarchive Item"
// "COPY_PRODUCT_FITMENTS" => "Copy Product Fitments"

export class Alert {
  _id: string;
  type: string;
  title: string;
  status: ProcessStatus;
  brand_relationship_id: number;
  total: number;
  user_id: number;
  updated_at: string;
  created_at: string;
  ended_at: string;
  progress: number;
  number_processed: number;
  units?: number;
}

export class ProcessResponse {
  current_page: number;
  data: Alert[];
  from: number;
  last_page: number;
  next_page_url: string | null;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export class WSProcessUpdateData {
  process: Alert;
}

export enum ProcessStatus {
  STATUS_STARTED = 1,
  STATUS_PROCESSING = 2,
  STATUS_COMPLETED = 3,
  STATUS_ERROR = 4,
}

export enum ProcessType {
  IMPORT_UPLOADED = `IMPORT_UPLOADED`
}
